import React from 'react';

const Footer= ({ informationData, navigationData, language = '' }: { informationData: any, navigationData: any, language?: string }) => {
    let infoData = informationData || {};
    let navData = navigationData?.item || {};
    
    // console.log("Footer Info Data", navData);

    return (
        <footer className="footer">
            <div className="container">
                <div className="information">
                    <div className="logo"><img src="/images/logo-octopus-3.png" alt="八達科技有限公司 Octopus InfoTech Limited." /></div>
                    <div className="info">
                        <p>{language=="en" ? "Tel" : "電話"} ：  <a href={`tel:${infoData.Tel}`}>{infoData.Tel}</a><br/>
                        {language=="en" ? "Fax" : "傳真"} ： {infoData.Fax}<br/>
                        {language=="en" ? "Email" : "電郵"} ： <a href={`mailto:${infoData.Email}`}>{infoData.Email}</a><br/>
                        {language=="en" ? "Address" : "地址"} : {infoData.Address}</p>
                        <div className='underline my-4'>{language=="en" ? "Accessibility Statement" : "無障礙聲明"}</div>
                        <div dangerouslySetInnerHTML={{ __html: infoData.Other }}></div>
                    </div>
                </div>
                <div className="site-map">
                    <h2>{language=="en" ? "Sitemap" : "網站分頁"}</h2>
                    <ul>
                        {navData?.map((item: any, index: number) => (
                            <li key={item.id || index} className={`${item.Display!=true ? "hidden" : ""}`}><a href={`/${language}${item.Url ? item.Url : '/'}`}>{item.Title}</a></li>
                        ))}
                    </ul> 
                </div>
                <div className="services-products-list">
                    <h2>{language=="en" ? "Services & Products" : "服務及產品"}</h2>
                    <ul>
                        {(() => {
                            const servicesItem = navData?.find((item: any) => item.dropdownId === "core-products");
                            return servicesItem?.subMenu?.map((subMenu: any, subIndex: number) => (
                                <React.Fragment key={subIndex}>
                                    <li className={`${subMenu.Display!=true ? "hidden" : ""}`}><a href={`/${language}${subMenu.url ? subMenu.url : '/'}`}>{subMenu.title}</a></li>
                                    {subMenu.Tier3 && subMenu.Tier3.length > 0 && (
                                        <ul className={subMenu.Display!=true ? "hidden" : ""}>
                                            {subMenu.Tier3.map((tier3Item: any, tier3Index: number) => (
                                                <li key={tier3Index} className={`tier3-item ${tier3Item.Display!=true ? "hidden" : ""}`}>
                                                    <a href={(tier3Item.Url ? `/${language}${tier3Item.Url}` : '/')}>{tier3Item.Title}</a>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </React.Fragment>
                            ));
                        })()}
                    </ul>      
                </div>
            </div>
        </footer>
    );
}

export default Footer;
